import { BasePagingResponse, BaseResponse } from './_base';

export enum CustomDataFieldType {
  LONG_TEXT = 'LONG_TEXT',
  TEXT = 'TEXT',
  SINGLE_SELECT = 'SINGLE_SELECT',
}

export enum CustomDataFieldUsage {
  CUSTOM_VARIABLES = 'CUSTOM_VARIABLES',
  PRE_ARRIVAL_FORM = 'PRE_ARRIVAL_FORM',
}

interface BaseCustomDataField {
  agencyUid: string;
  uid: string;
  type: CustomDataFieldType;
  name: string;
  variable: string;
}

export interface LeadCustomDataField extends BaseCustomDataField {
  usage: CustomDataFieldUsage;
}

export interface CustomDataField extends BaseCustomDataField {
  index: number;
}

export interface CreateCustomDataFieldResponse {
  customDataField: CustomDataField;
}

export interface GetCustomDataFieldsResponse
  extends BasePagingResponse,
    BaseResponse {
  customDataFields: CustomDataField[];
}

export enum InternalCustomDataFieldSubType {
  PRIMARY_GUEST_INFORMATION = 'PRIMARY_GUEST_INFORMATION',
  OTHER_GUEST_INFORMATION = 'OTHER_GUEST_INFORMATION',
  ARRIVAL_INFORMATION = 'ARRIVAL_INFORMATION',
  OTHER = 'OTHER',
}

interface SingleSelectTypeOptionsPayload {
  optionText: string;
  optionValue: string;
  sortOrder: number;
  isActive: boolean;
}

interface SingleSelectTypeOptionsResponse
  extends Pick<
    SingleSelectTypeOptionsPayload,
    'optionText' | 'optionValue' | 'sortOrder'
  > {
  id: number;
  uid: string;
  customDataFieldUid: string;
  active: boolean;
}

export interface InternalCustomDataField extends BaseCustomDataField {
  index: number;
  minAgeToShow: number | null;
  isActive: boolean;
  isOptional: boolean;
  subType: InternalCustomDataFieldSubType;
  options?: SingleSelectTypeOptionsResponse[];
}

export interface GetPreArrivalCustomFieldsResponse extends BaseResponse {
  customDataFields: InternalCustomDataField[];
}

interface UpdateInternalCustomDataField {
  uid: string;
  type?: never; // ignored
  name?: never; // ignored
  subType?: never; // ignored
  index?: never; // ignored

  minAgeToShow?: number | null;
  isActive?: boolean;
  isOptional?: boolean;
}

interface CreateInternalCustomDataField {
  uid?: never; // should not be provided
  type: CustomDataFieldType;
  name: string;
  subType?: InternalCustomDataFieldSubType;
  index?: number;
  minAgeToShow?: number | null;
  isActive?: boolean;
  isOptional?: boolean;
  options?: SingleSelectTypeOptionsPayload[];
}

type CustomDataFieldPayload =
  | UpdateInternalCustomDataField
  | CreateInternalCustomDataField;

export interface UpdateCustomDataFieldsInternalPayload {
  customDataFields: CustomDataFieldPayload[];
}
